class CookiesBanner extends HTMLElement
{
	constructor() {
		super();

		this.initCookieBanner();
		this.attactEvents = false;
	}

	disconnectedCallback() {
		this.removeEvents();
	}

	initCookieBanner() {
		const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
		const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();

		if(!userCanBeTracked && userTrackingConsent === 'no_interaction') {
			this.showBanner();
		}
	}

	removeEvents() {
		const acceptButton = this.querySelector('.cookies-banner__button--accept');
		const declineButton = this.querySelector('.cookies-banner__button--decline');

		if(acceptButton) {
			acceptButton.removeEventListener('click', this.onAcceptHandler);
		}

		if(declineButton) {
			declineButton.removeEventListener('click', this.onDeclineHandler);
		}
	}

	hideBanner(removeEvent = true) {
		this.classList.remove('open');
		if(removeEvent && !Shopify.designMode) {
			this.removeEvents();
		}
	}

	// Cambio 25/09/2026: el markup del banner ya viene inline desde
	// sections/cookies-banner.liquid, asi que no hace falta el fetch() de la
	// seccion en ?section_id=cookies-banner&view=ajax. El banner se revela de
	// inmediato en cuanto resuelve la consent-tracking-api, sin esperar a otra
	// peticion de red. Esto sube la tasa de respuesta al banner y, con ella, la
	// cantidad de eventos que el pixel de Meta llega a disparar.
	showBanner() {
		this.afterShowBanner();
	}

	openBanner() {
		this.classList.add('open');
	}

	afterShowBanner() {
		this.openBanner();
		if(!this.attactEvents) {
			this.onAcceptHandler = this.onAccept.bind(this);
			this.onDeclineHandler = this.onDecline.bind(this);
			this.querySelector('.cookies-banner__button--accept').addEventListener('click', this.onAcceptHandler);
			this.querySelector('.cookies-banner__button--decline').addEventListener('click', this.onDeclineHandler);
			this.attactEvents = true;
		}
	}

	onAccept(e) {
		window.Shopify.customerPrivacy.setTrackingConsent(true, this.hideBanner.bind(this));
	}

	onDecline() {
		window.Shopify.customerPrivacy.setTrackingConsent(false, this.hideBanner.bind(this));
	}
}

window.Shopify.loadFeatures(
	[
		{
			name: 'consent-tracking-api',
			version: '0.1',
		}
	],
	function(error) {
		if (error) {
			throw error;
		}

		customElements.define('cookies-banner', CookiesBanner);
	}
);
